import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import {
  formatSubscriptionExpiry,
  getSubscriptionAlert,
} from "../utils/userProfile";

function formatPlanLabel(subscription) {
  if (!subscription?.label) return "Бизнес-подписка";
  const max = subscription.teamSizeMax;
  return max ? `${subscription.label} · до ${max} чел.` : subscription.label;
}

export default function KeyAvaileble({ businessSubscription }) {
  const activeUntil = formatSubscriptionExpiry(businessSubscription);
  const isActive = Boolean(activeUntil);
  const alert = getSubscriptionAlert(businessSubscription);
  const isWarning = alert?.severity === "warning";
  const planLabel = formatPlanLabel(businessSubscription);

  if (!isActive) {
    return (
      <div className="app-subscription-widget app-subscription-widget--inactive">
        <div className="app-subscription-widget__icon-wrap app-subscription-widget__icon-wrap--inactive">
          <BusinessCenterOutlinedIcon fontSize="small" />
        </div>
        <div className="app-subscription-widget__body">
          <span className="app-subscription-widget__eyebrow">Подписка</span>
          <strong className="app-subscription-widget__title">
            Не подключена
          </strong>
          <p className="app-subscription-widget__desc">
            Оформите тариф, чтобы публиковать сценарии и открыть доступ команде
            по ссылке в Telegram
          </p>
        </div>
        <Link to="/main/price" className="app-subscription-widget__cta-link">
          <Button
            variant="contained"
            size="small"
            className="app-btn app-btn--primary app-subscription-widget__cta"
          >
            Выбрать тариф
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div
      className={`app-subscription-widget app-subscription-widget--active${
        isWarning ? " app-subscription-widget--warning" : ""
      }`}
    >
      <div
        className={`app-subscription-widget__icon-wrap${
          isWarning
            ? " app-subscription-widget__icon-wrap--warning"
            : " app-subscription-widget__icon-wrap--active"
        }`}
      >
        {isWarning ? (
          <WarningAmberOutlinedIcon fontSize="small" />
        ) : (
          <CheckCircleOutlineIcon fontSize="small" />
        )}
      </div>
      <div className="app-subscription-widget__body">
        <span className="app-subscription-widget__eyebrow">{planLabel}</span>
        <strong className="app-subscription-widget__title">
          {isWarning ? "Скоро закончится" : "Подписка активна"}
        </strong>
        <p className="app-subscription-widget__desc">
          {isWarning && alert?.daysLeft
            ? `Осталось ${alert.daysLeft} дн. · действует до ${activeUntil}`
            : `Групповой доступ открыт до ${activeUntil}`}
        </p>
      </div>
      <Link to="/main/price" className="app-subscription-widget__cta-link">
        <Button
          variant={isWarning ? "contained" : "outlined"}
          size="small"
          className={`app-btn app-subscription-widget__cta${
            isWarning ? " app-btn--primary" : ""
          }`}
        >
          {isWarning ? "Продлить" : "Тарифы"}
        </Button>
      </Link>
    </div>
  );
}
